var _templateObject = _taggedTemplateLiteralLoose(['\n  font-family: ', ';\n  color: ', ';\n  opacity: 0;\n  text-align: center;\n\n  ', '\n'], ['\n  font-family: ', ';\n  color: ', ';\n  opacity: 0;\n  text-align: center;\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-family: ', ';\n'], ['\n  color: ', ';\n  font-family: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: 0.75rem;\n  font-weight: 400;\n'], ['\n  color: ', ';\n  font-size: 0.75rem;\n  font-weight: 400;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import { Container } from 'reactstrap';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Theme from '../../Theme';
import { openThankyouViewAnim } from './animations';

var _Theme$fonts = Theme.fonts,
    PlayfairDisplay = _Theme$fonts.PlayfairDisplay,
    Montserrat = _Theme$fonts.Montserrat;
var _Theme$colors = Theme.colors,
    primary = _Theme$colors.primary,
    blueGrey = _Theme$colors.blueGrey;


var Wrapper = styled(Container)(_templateObject, Montserrat, blueGrey, function (props) {
  return props.open && openThankyouViewAnim;
});

var Heading = styled.h2(_templateObject2, primary, PlayfairDisplay);

var Subheading = styled.p(_templateObject3, blueGrey);

var ThankyouView = function ThankyouView(_ref) {
  var open = _ref.open;
  return React.createElement(
    Wrapper,
    { open: open },
    React.createElement(
      Heading,
      null,
      'Thank you!'
    ),
    React.createElement(
      Subheading,
      null,
      'We appreciate your feedback.'
    )
  );
};

ThankyouView.propTypes = process.env.NODE_ENV !== "production" ? {
  open: PropTypes.bool
} : {};

export default ThankyouView;